<div class="haeder-select flex flex-center">
  <div>
    <mat-form-field
      appearance="outline"
      class="custom-select"
      [ngClass]="'custom-select category-' + selectedCategory().class"
    >
      <mat-select [formControl]="selectControl">
        <mat-select-trigger data-fs-element="Open-Search-Button-Gallery-Filter">
          <div class="trigger-content flex flex-center">
            <div class="flex flex-center text">
              <mat-icon class="icon">{{ selectedCategory().icon }}</mat-icon>
              @if (selectedCategory().value === 0) {
                <span class="body-medium">{{ ALL_CATEGORIES_KEY | translate }}</span>
              } @else {
                <span class="body-medium">{{ selectedCategory().label | changeLanguage }}</span>
              }
            </div>
            <mat-icon class="icon-expand">expand_more</mat-icon>
          </div>
        </mat-select-trigger>
        @if (categoryOptions()) {
          @for (cat of categoryOptions(); track cat.value) {
            @if (cat.value != 5) {
              <mat-option
                data-fs-element="Open-Search-Gallery-Filter-Item"
                [value]="cat.value"
                [ngClass]="'category-' + cat.class"
              >
                <div class="option-content">
                  <mat-icon class="icon">{{ cat.icon }}</mat-icon>
                  @if (cat.value === 0) {
                    <span class="body-medium">{{ ALL_CATEGORIES_KEY | translate }}</span>
                  } @else {
                    <span class="body-medium">{{ cat.label | changeLanguage }}</span>
                  }
                </div>
              </mat-option>
            }
          }
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (searchPanelSignal()) {
    <div class="line">
      <mat-divider />
    </div>
    <div class="search-wrapper" [class.expanded]="showSearch">
  <button mat-icon-button (click)="toggleSearch()" class="search-btn" data-fs-element="Open-Search-Gallery-Button-Search">
        <mat-icon fontIcon="search" class="icon-m"></mat-icon>
      </button>

      <input
        data-fs-element="Open-Search-Gallery-Input-Search"
        type="text"
        [(ngModel)]="searchText"
        class="search-input"
        placeholder="Search"
        (blur)="closeSearch()"
      />
    </div>
  }
</div>
